// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * This module provides workspace interface for application team.
 *
 * @module js/swf3dWorkspaceAPI
 */
import config from 'js/swf3dWorkspaceConfig';
import utils from 'js/swf3dWorkspaceUtils';
import { http } from '@swf3d/utils';
import input from 'js/swf3dWorkspaceInput';

// Interface for application team to setup workspace.
let API = {};

/**
 * Interface for get Collaborationspace ID.
 *
 * @memberof js/swf3dWorkspaceAPI
 * @function getCollaborationspaceId
 * @param {object} getOptions - get object options
 * @example
 * swf3dWorkspaceAPI.getCollaborationspaceId({});
 * @returns {Promise} - collab space ID
 */
API.getCollaborationspaceId = function (getOptions) {
    let url = config.url + '/collab/collaborationspace';
    let inputData = { ...input.getCollabInputData(), ...getOptions };

    return http.get(url, { data: JSON.stringify(inputData) }).then(res => {
        if (res && res[0]) {
            return res[0].collaborationspaceId;
        }
        return '';
    });
};

export default API;
